import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIconCapsule = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 76 75'
    {...props}
  >
    <path
      fill='#222B5F'
      d='M65.731 75H9.68c-5.21 0-9.474-4.263-9.474-9.474V9.474C.205 4.264 4.468 0 9.68 0H65.73c5.21 0 9.474 4.263 9.474 9.474v56.052A9.45 9.45 0 0 1 65.731 75'
    />
    <path
      fill='#fff'
      d='M10.074 54.553h6.868v-4.342h8.842v4.342h6.868V21.237H10.074zM44.81 12c-1.026 0-1.894.868-1.894 1.895 0 1.026.868 1.895 1.894 1.895 1.027 0 1.895-.869 1.895-1.895 0-1.105-.868-1.895-1.895-1.895M44.81 20.685c-1.026 0-1.894.868-1.894 1.894 0 1.027.868 1.895 1.894 1.895 1.027 0 1.895-.868 1.895-1.895 0-1.026-.868-1.894-1.895-1.894M44.81 29.447c-1.026 0-1.894.869-1.894 1.895s.868 1.895 1.894 1.895c1.027 0 1.895-.869 1.895-1.895s-.868-1.895-1.895-1.895M53.653 12c-1.027 0-1.895.868-1.895 1.895 0 1.026.868 1.895 1.895 1.895 1.026 0 1.894-.869 1.894-1.895 0-1.105-.868-1.895-1.894-1.895M53.653 20.685c-1.027 0-1.895.868-1.895 1.894 0 1.027.868 1.895 1.895 1.895 1.026 0 1.894-.868 1.894-1.895 0-1.026-.868-1.894-1.894-1.894M53.653 29.447c-1.027 0-1.895.869-1.895 1.895s.868 1.895 1.895 1.895c1.026 0 1.894-.869 1.894-1.895s-.868-1.895-1.894-1.895M62.416 12c-1.027 0-1.895.868-1.895 1.895 0 1.026.868 1.895 1.895 1.895 1.026 0 1.894-.869 1.894-1.895 0-1.105-.868-1.895-1.894-1.895M62.416 20.685c-1.027 0-1.895.868-1.895 1.894 0 1.027.868 1.895 1.895 1.895 1.026 0 1.894-.868 1.894-1.895 0-1.026-.868-1.894-1.894-1.894M62.416 29.447c-1.027 0-1.895.869-1.895 1.895s.868 1.895 1.895 1.895c1.026 0 1.894-.869 1.894-1.895s-.868-1.895-1.894-1.895'
    />
    <path
      fill='#E02179'
      d='M21.6 42.947C15.363 42.789 10.152 47.763 9.995 54c-.158 6.236 4.815 11.447 11.052 11.605s11.448-4.816 11.605-11.053A11.306 11.306 0 0 0 21.6 42.947m3.552 15.395h-7.579v-7.58h7.58z'
    />
    <path
      fill='#42BB9C'
      d='M21.363 32.92c6.235 0 11.29-5.054 11.29-11.289s-5.055-11.29-11.29-11.29-11.29 5.055-11.29 11.29 5.055 11.29 11.29 11.29M41.968 40.815v23.369h23.369V40.815zM60.521 57.79H46.705v-2.92h13.816zm0-7.658H46.705v-2.92h13.816z'
    />
  </svg>
);
export default SvgIconCapsule;
